import lazyLoading from './lazyLoading';

export default {
  name: 'Car Parks',
  meta: {
    expanded: false,
    title: 'menu.park',
    iconClass: 'fas fa-parking',
  },
  children: [
    {
      name: 'Parking Bays',
      path: '/park/bays/:id?',
      component: lazyLoading('parkec/PARK_Bays'),
      meta: {
        // default: true,
        title: 'schema.park_bays',
        iconClass: 'fas fa-parking',
        to: '/park/bays',
        auth: ['admin', 'landlord']
      },
      props: r => ({root: true, id: r.params.id}),
    },
    {
      name: 'Bookings',
      path: '/park/bookings/:id?',
      component: lazyLoading('parkec/PARK_Bookings'),
      meta: {
        title: 'schema.park_bookings',
        iconClass: 'fas fa-clipboard-list',
        to: '/park/bookings',
        auth: ['admin', 'landlord']
      },
      props: r => ({root: true, id: r.params.id}),
    },
  ],
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/park.js